/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import {
    AssignmentPrioritizationRequest,
    FullAssignment,
    IdKeyDictionary,
    OperationSuccess,
    Pagination,
    User,
} from "../../utils/Interfaces";
import { buildGetRequest, buildPostRequest } from "../../utils/Requests";

export function getActiveAssigneesList() {
    return buildGetRequest<Pagination<User>>("/api/assignments/get-active-assignees");
}

export function getAssignmentsForUser(userId: number) {
    return buildGetRequest<Pagination<FullAssignment>>(`/api/assignments/list-by-user/open/${userId}`);
}

export function editAssignmentPriorities(assignments: FullAssignment[]) {
    const assignmentsMap: IdKeyDictionary = {};

    assignments.forEach((item: FullAssignment, key: number) => (assignmentsMap[item.id.toString()] = key));

    return buildPostRequest<AssignmentPrioritizationRequest, OperationSuccess>("/api/assignments/prioritize", {
        assignments: assignmentsMap,
    });
}
